import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function AnnouncementModal({ announcement, onClose }) {
  if (!announcement) return null;

  // Mapping von bgType aus dem JSON auf passende Bootstrap Text- / Button-Klassen
  const colorMap = {
    warning: { text: "text-warning", btn: "warning" },
    danger: { text: "text-danger", btn: "danger" },
    info: { text: "text-info", btn: "info" },
    success: { text: "text-success", btn: "success" },
  };

  // Fallback auf "success", falls ein unbekannter Typ eingegeben wird
  const activeColor = colorMap[announcement.bgType] || colorMap.success;

  return (
    <Modal
      show={!!announcement}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={true}
      className="announcement-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        {/* Dynamische Textfarbe für die Überschrift */}
        <Modal.Title className={`fw-bold fs-4 ${activeColor.text}`}>
          {announcement.modalTitle}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-2">
        <p className="text-muted mb-3">{announcement.modalContent}</p>

        {announcement.items && announcement.items.length > 0 && (
          <ul className="list-group list-group-flush mb-2 border-top">
            {announcement.items.map((item, index) => (
              <li
                key={index}
                className="list-group-item bg-transparent px-0 py-2 d-flex align-items-center gap-2 text-dark"
              >
                {/* Dynamische Farbe für die Häkchen */}
                <span className={`fw-bold ${activeColor.text}`}>✓</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        {/* Dynamischer Button-Stil */}
        <Button
          variant={activeColor.btn}
          className="fw-bold px-4 text-white"
          onClick={onClose}
        >
          Verstanden
        </Button>
      </Modal.Footer>
    </Modal>
  );
}